import { useCallback, useEffect, useMemo, useState } from "react";
// import { useLoader } from "../../context/LoaderProvider";
import { translateDataToArabic } from "../helpers/usetranslateDataToArabic";
import useSyncLanguage from "../helpers/useSyncLanguage";
import { useLoader } from "../context/LoaderProvider";

export const useTranslatableData = ({ dataMap = {}, langKey = 'language' }) => {
  const [translatedData, setTranslatedData] = useState(dataMap);
  const [currentLang, setCurrentLang] = useState(sessionStorage.getItem(langKey) || 'en');
  const [loading, setLoading] = useState(false);
   const { setShowLoader } = useLoader();

  // ✅ Sync language across tabs and within tab
  useSyncLanguage(setCurrentLang);

  // ✅ Memoize the data map to avoid unnecessary re-renders
  const stableDataMap = useMemo(() => dataMap, [JSON.stringify(dataMap)]);

  const updateLanguage = useCallback(async (lang = currentLang) => {
    try {
      if (lang === 'ar') {
        setLoading(true);
        setShowLoader(true);
        const response = await translateDataToArabic(stableDataMap);
        setTranslatedData(response);
        setShowLoader(false);
      } else {
        setTranslatedData(stableDataMap);
      }
    } catch (error) {
      console.error("Translation error:", error);
      setTranslatedData(stableDataMap); // fallback
    } finally {
      setLoading(false);
    }
  }, [stableDataMap, currentLang]);

  useEffect(() => {
    const shouldTranslate = Object.values(stableDataMap).every(
      (val) => val && (Array.isArray(val) ? val.length > 0 : Object.keys(val).length > 0)
    );

    if (shouldTranslate) {
      updateLanguage(currentLang);
    }
  }, [currentLang, updateLanguage, stableDataMap]);

  return {
    translatedData,
    currentLang,
    setCurrentLang,
    updateLanguage,
    loading,
  };
};
